// src/i18n/en/hotels.ts

const hotels = {
  name: 'Property |||| Properties',
  
  fields: {
    id: 'ID',
    name: 'Property Name',
    groupId: 'Group',
    groupName: 'Group Name',
    directoryId: 'Registry establishment',
    registry: 'Registry',
    address: 'Address',
    city: 'City',
    country: 'Country',
    postalCode: 'Postal Code',
    deviceCount: 'Devices',
    activeDevices: 'Active Devices',
    analyticsEnabled: 'Insight Enabled',
    source: 'Source',
    isActive: 'Active',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    checkInsToday: 'Check-ins Today',
    checkInsThisWeek: 'Check-ins This Week',
    checkInsThisMonth: 'Check-ins This Month',
  },

  hints: {
    groupOptional: 'Leave the group empty for an independent property.',
  },

  actions: {
    create: 'Create Property',
    edit: 'Edit Property',
    delete: 'Delete Property',
    view: 'View Property',
    list: 'Properties List',
    viewStats: 'View Statistics',
    forceDelete: 'Force Delete',
    forceDeleteConfirm: 'Delete Permanently',
    confirmForceDelete: 'Delete Permanently',
  },
  
  messages: {
    create_success: 'Property created successfully',
    create_error: 'Error creating property',
    update_success: 'Property updated successfully',
    update_error: 'Error updating property',
    delete_success: 'Property deleted successfully',
    delete_error: 'Error deleting property',
    delete_confirm: 'Are you sure you want to delete this property?',
    delete_with_devices: 'Cannot delete property with devices registered',
    delete_with_checkins: 'Cannot delete property with recent check-ins (last 30 days)',
    no_hotels: 'No properties available',
    loading: 'Loading properties...',
    group_not_found: 'Group not found',
    // Force delete messages
    force_delete_warning_short: 'Permanently delete property and all data',
    forceDeleteCaption: 'Permanently delete property and all data',
    forceDeleteConfirm: 'Force Delete Property',
    forceDeleteDanger: 'This action is IRREVERSIBLE and will permanently delete ALL data.',
    forceDeleteWarning: 'Are you sure you want to permanently delete property "%{hotelName}" and ALL its associated data?',
    forceDeleteWillRemove: 'This will permanently delete',
    forceDeleteComplete: 'Property and all associated data have been permanently deleted.',
    forceDeleteSummary: 'Deletion summary',
    forceDeleteSuccess: 'Property force deleted successfully',
    forceDeleteError: 'Error force deleting property',
    allDevices: 'All devices',
    allJourneys: 'All check-in journeys',
    allEvents: 'All events and errors',
    theHotel: 'The property itself',
    deletedDevices: 'Devices deleted',
    deletedJourneys: 'Journeys deleted',
    deletedEvents: 'Events deleted',
    deletedHotels: 'Properties deleted',
    // Force delete dialog
    force_delete_confirm: 'Force Delete Property',
    force_delete_warning: 'This action is IRREVERSIBLE and will permanently delete ALL data associated with this property.',
    force_delete_description: 'Are you sure you want to permanently delete property "%{name}" and ALL its associated data?',
    force_delete_will_remove: 'This will permanently delete',
    force_delete_item_devices: '%{count} device |||| %{count} devices',
    force_delete_item_journeys: 'All check-in journeys',
    force_delete_item_events: 'All events and errors',
    force_delete_item_config: 'Property configuration',
    force_delete_completed: 'Property and all associated data have been permanently deleted.',
  },
  
  validation: {
    name_required: 'Property name is required',
    name_min_length: 'Property name must be at least 3 characters',
    name_max_length: 'Property name cannot exceed 100 characters',
    address_max_length: 'Address cannot exceed 200 characters',
    city_max_length: 'City cannot exceed 100 characters',
    country_max_length: 'Country cannot exceed 100 characters',
    postal_code_max_length: 'Postal code cannot exceed 20 characters',
    group_required: 'Group selection is required',
  },
  
  list: {
    title: 'Properties',
    empty: 'No properties found',
    search: 'Search properties...',
  },
  
  show: {
    title: 'Property Details',
    basic_info: 'Basic Information',
    location_info: 'Location',
    devices_section: 'Devices',
    statistics: 'Statistics',
    recent_activity: 'Recent Activity',
    no_devices: 'No devices registered for this property',
    metadata: 'Metadata',
  },
  
  create: {
    title: 'Create New Property',
    subtitle: 'Add a new property to the system',
  },
  
  edit: {
    title: 'Edit Property',
    subtitle: 'Modify property information',
  },
  
  source: {
    Manual: 'Manual',
    Updater: 'Auto-registered',
  },
  
  stats: {
    title: 'Property Statistics',
    devices: 'Devices',
    checkins: 'Check-ins',
    performance: 'Performance',
    channels: 'Channels',
    average_time: 'Average Check-in Time',
    completion_rate: 'Pre-check-in Completion',
    auto_keys: 'Keys Dispensed Automatically',
  },
  
  notifier: {
    title: 'Notification Settings',
    subtitle: 'Configure alert notifications and channels',
    sections: {
      summary: 'Configuration Summary',
      channels: 'Notification Channels',
    },
    fields: {
      apiKey: 'API Key',
      accountName: 'Account Name',
      enabled: 'Enabled',
      channelType: 'Channel Type',
      recipients: 'Recipients',
      alertMappings: 'Alert Mappings',
      templateId: 'Template ID',
      useCustomMessage: 'Use Custom Message',
      alertType: 'Alert Type',
      customSubject: 'Custom Subject',
      customMessage: 'Custom Message',
      template: 'Template',
    },
    help: {
      apiKey: 'Enter your notification service API key',
      accountName: 'Enter the account name for the notification service',
    },
    actions: {
      add_channel: 'Add Channel',
      disable_all: 'Disable All Alerts',
      save: 'Save Configuration',
      add: 'Add',
      add_mapping: 'Add Mapping',
    },
    alertTypes: {
      DeviceOffline: 'Device Offline',
      HighErrorRate: 'High Error Rate',
      LowCompletionRate: 'Low Completion Rate',
      SystemError: 'System Error',
    },
    placeholders: {
      recipient: 'Email address',
      templateId: 'Enter template ID',
      email: 'Enter email address',
      phone: 'Enter phone number',
      selectTemplate: 'Select a template',
    },
    messages: {
      channels_count: '{{count}} channel(s) configured, {{enabled}} enabled',
      credentials_configured: 'API credentials are configured',
      credentials_missing: 'Please configure API credentials to enable notifications',
      no_channels: 'No notification channels configured',
      save_success: 'Notification configuration saved successfully',
      no_templates: 'No templates available',
    },
  },
};

export default hotels;